const LOGIN = 'login'
const REGISTER = 'register'

export { LOGIN, REGISTER }
